/*** Engraving textarea show hide ***/
window.addEventListener("DOMContentLoaded", (event) => {
  const bodymain = document.querySelector("body");

  // ⬇️ NEW: feature-detect the engraving wrapper and bail out if absent
  const engravingsContainer = document.querySelector(".engravings_wrap");
  if (!engravingsContainer) {
    // Optional: make sure upsell flag is reset when there is no engraving
    if (window.productUpsells?.model) {
      window.productUpsells.model.engravingFlag = false;
    }
    return; // nothing to wire up on "no-engraving" products
  }

  // Safe to read children from here on
  const engravingPopup = engravingsContainer.querySelector(".engravingpopup");
  const addEngravingBtn = document.querySelector(".box_engrave .add-engraving-btn");

  function handleAddEngravingClick() {
    engravingPopup?.classList.add("open_popup"); // ⬅ add '?' to be extra defensive
    bodymain.classList.add("active_engraving");
  }

  // ⬇️ Guard in case button is missing even when wrapper exists
  if (addEngravingBtn) {
    addEngravingBtn.addEventListener("click", handleAddEngravingClick);
  }
/** Original code from (I guess) Monika that causes an error in products with no-engraving tag.

   const bodymain = document.querySelector("body");
  const engravingsContainer = document.querySelector(".engravings_wrap");
  const engravingPopup = engravingsContainer.querySelector(".engravingpopup");
  const addEngravingBtn = document.querySelector( ".box_engrave .add-engraving-btn");
  function handleAddEngravingClick() {
    engravingPopup.classList.add("open_popup");
    bodymain.classList.add("active_engraving");
  }
  
  addEngravingBtn.addEventListener("click", handleAddEngravingClick);
  
   */
  
  // $(".close_div svg").click(closePopup);
  // $(".engravingpopup").click(closePopup);

  $(".close_div svg").click(function () {
    resetEngravingSelection();
    closePopup();
  });

  $(".engravingpopup").click(function () {
    resetEngravingSelection();
    closePopup();
  });
  
  $(".engravingpopup_inner").click(function (e) {
    e.stopPropagation();
  });

  function resetEngravingSelection() {
    productUpsells.model.engravingFlag = false;

    Object.keys(store).forEach(function (type) {
      store[type] = {
        font: store[type]?.font || fontSelectElements[0]?.value || "Arial"
      };
    });

    engravingPreviewTextareas.forEach(function (textarea) {
      textarea.value = "";
    });

    fileInputs.forEach(function (input) {
      input.value = "";
    });

    document.querySelectorAll(".engraving-image-preview").forEach(function (preview) {
      preview.innerHTML = "";
    });

    document.querySelectorAll("#fileLabel").forEach(function (label) {
      label.innerHTML = "No file chosen";
    });

    renderView();
  }

  function closePopup() {
    $(".engravingpopup").removeClass("open_popup");
    $("body").removeClass("active_engraving");
  }
  const EngravingTypes = {
    Men: "men",
    Women: "women",
    Single: "single"
  };

  const store = {
    [EngravingTypes.Men]: null,
    [EngravingTypes.Women]: null,
    [EngravingTypes.Single]: null
  };

  
  const engravingBoards =
    engravingsContainer.querySelectorAll(".engraving-text");
  const proceedBtns = engravingsContainer.querySelectorAll(
    ".engraving-proceed-btn"
  );

  const engravingErrorMessages = engravingsContainer.querySelectorAll('.engraving-error-message');
 
  const fontSelectElements = engravingsContainer.querySelectorAll(".select-font");

  const fileInputs = engravingsContainer.querySelectorAll(".engraving-image");
  
  const addToCartBtn = document.querySelector(
    ".product .product_form .add_to_cart"
  );
  

  fontSelectElements.forEach(function (selectElement) {
    selectElement.addEventListener("change", handleFontChange);
  });

  proceedBtns.forEach((btn) => {
    btn.addEventListener("click", handleProceedBtnClick);
  });

  fileInputs.forEach((input) => {
    input.addEventListener("change", handleFileInputChange);
  })

 console.log({ store });

  function initializeStore() {
    const defaultFont = fontSelectElements[0]?.value
    store[EngravingTypes.Men] = {
      font: defaultFont ?? "Arial",
    };
    store[EngravingTypes.Women] = {
      font: defaultFont ?? "Arial",
    };
    store[EngravingTypes.Single] = {
      font: defaultFont ?? "Arial",
    };
  }

  initializeStore();

  function normalizeAndLimitLines(str, maxLines) {
    if (!str) return "";
    const normalized = String(str).replace(/\r/g, ""); // drop Windows returns
    const parts = normalized.split("\n");
    return parts.slice(0, maxLines > 0 ? maxLines : parts.length).join("\n");
  } 
 

  function handleProceedBtnClick(e) {
    const btn = e.currentTarget;
    
    if (
      ((store[EngravingTypes.Men]?.message || store[EngravingTypes.Men]?.file) &&
       (store[EngravingTypes.Women]?.message || store[EngravingTypes.Women]?.file)) || 
       (store[EngravingTypes.Single]?.message || store[EngravingTypes.Single]?.file)
    ) {
      //close popup and add to cart
      setTimeout(() => $(engravingPopup).hide(), 100);
      productUpsells.model.engravingFlag = true;
      addToCartBtn.click();
    } else {
      //go to next screen
      if (btn.dataset.type === EngravingTypes.Women) {
        document.querySelector(".engravingman_btn .engraving_man").click();
      } else if (btn.dataset.type === EngravingTypes.Men) {
        document.querySelector(".engravingwoman_btn .engraving_woman").click();
      }
    }
  }

  function handleTextAreaChange(e) {
    const textarea = e.target;
    const type = textarea.dataset.type;
    const maxLines = parseInt(textarea.dataset.maxLines || "2", 10); // NEW

    const val = normalizeAndLimitLines(textarea.value, maxLines);

    // reflect trimmed value in the UI so users see the limit immediately
    if (val !== textarea.value) textarea.value = val;

    // update store
    if (type === EngravingTypes.Women) {
      store[EngravingTypes.Women].message = val;
    } else if (type === EngravingTypes.Men) {
      store[EngravingTypes.Men].message = val;
    } else if (type === EngravingTypes.Single) {
      store[EngravingTypes.Single].message = val;
    }

    renderView();
  }

  /** Original function from Monika. 
  function handleTextAreaChange(e) {
    const textarea = e.target;
    //update value in store
    //Women must come first, as women contains men
    if (textarea.dataset.type === EngravingTypes.Women) {
      store[EngravingTypes.Women].message = textarea.value;
    } else if (textarea.dataset.type === EngravingTypes.Men) {
      store[EngravingTypes.Men].message = textarea.value;
    } else if (textarea.dataset.type === EngravingTypes.Single) {
      store[EngravingTypes.Single].message = textarea.value;
    }

    //update everything w.r.t store
    renderView();
  } */

  function handleFontChange(e) {
    const select = e.target;

    //update value in store
    //Women must come first, as women contains men
    if (select.dataset.type === EngravingTypes.Women) {
      store[EngravingTypes.Women].font = select.value;
    } else if (select.dataset.type === EngravingTypes.Men) {
      store[EngravingTypes.Men].font = select.value;
    } else if (select.dataset.type === EngravingTypes.Single) {
      store[EngravingTypes.Single].font = select.value; 
    }

    renderView();
  }

function handleFileInputChange(e) {
  const input = e.target;
  const file = input.files[0];

  store[input.dataset.type].file = file;

  const previewWrap = input
    .closest('.line-item-property__field')
    ?.querySelector('.engraving-image-preview');

  if (previewWrap) {
    previewWrap.innerHTML = '';

    if (file && file.type.startsWith('image/')) {
      const img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = file.name;
      img.loading = 'lazy';
      previewWrap.appendChild(img);
    }
  }

  renderView();
}

  function renderView() {
    engravingBoards.forEach((board) => {
      board.textContent = store[board.dataset.type]?.message ?? "";
      board.style.fontFamily = `${store[board.dataset.type]?.font}, sans-serif`;
    });

    //this is if we need to apply fonts to select element as well
    // fontSelectElements.forEach((select) => {
    //   select.style.fontFamily = `${store[select.dataset.type]?.font}, sans-serif`;
    // });

    proceedBtns.forEach((btn) => {
      btn.disabled = !store[btn.dataset.type]?.message?.length && !store[btn.dataset.type]?.file;
    });

    engravingErrorMessages.forEach((message) => {
      const requirementsFulfilled = !!store[message.dataset.type]?.message?.length || !!store[message.dataset.type]?.file;
      if (requirementsFulfilled) {
        message.classList.add('invisible')
      } else {
        message.classList.remove('invisible')
      }
    })
  }

  const engravingPreviewTextareas = document.querySelectorAll(".engraving");
  engravingPreviewTextareas.forEach((textarea) =>
    textarea.addEventListener("input", handleTextAreaChange)
  );
  // updateEngravingText(e);
  $(".engravingman_btn .engraving_man").click(function () {
    var $firstPopup = $(this).closest(".first_popup");
    $firstPopup.addClass("hide");
    $firstPopup.next(".mens_customize_box").removeClass("hide");
    $firstPopup.next(".mens_customize_box").next(".womens_customize_box").addClass("hide");
});

$(".engravingwoman_btn .engraving_woman").click(function () {
    var $firstPopup = $(this).closest(".first_popup");
    $firstPopup.addClass("hide");
    $firstPopup.next(".mens_customize_box").addClass("hide");
    $firstPopup.next(".mens_customize_box").next(".womens_customize_box").removeClass("hide");
});

$(".backbtn_wrap").click(function () {
    $(".engravingpopup_row").addClass("hide");
    $(".first_popup").removeClass("hide");
});

var inputs = document.querySelectorAll('.inputtypefile');
inputs.forEach(function(input) {
    input.addEventListener('change', function() {
        var label = this.nextElementSibling;
        if (this.value === "") {
            label.innerHTML = "No file chosen";
        } else {
            var theSplit = this.value.split('\\');
            label.innerHTML = theSplit[theSplit.length - 1];
        }
    });
});
$('.customfilebtn').click(function() {
    var input = $(this).next();
    input.click();
});  
});
